
      import API from "!../../../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/style-loader/dist/runtime/singletonStyleDomAPI.js";
      import insertFn from "!../../../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../node_modules/.pnpm/style-loader@3.3.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[2].use[1]!../../../../../node_modules/.pnpm/postcss-loader@8.1.1_@rspack+core@1.1.0_@swc+helpers@0.5.12__postcss@8.4.38_typescript@5.0.4__5lvnl7xmoydmkkvnqez3gfmijq/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[2].use[2]!./dd-messages.css";
      
      

var options = {};

;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.91.0_@swc+core@1.7.6_@swc+helpers@0.5.12__/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[2].use[1]!../../../../../node_modules/.pnpm/postcss-loader@8.1.1_@rspack+core@1.1.0_@swc+helpers@0.5.12__postcss@8.4.38_typescript@5.0.4__5lvnl7xmoydmkkvnqez3gfmijq/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[2].use[2]!./dd-messages.css";
       export default content && content.locals ? content.locals : undefined;
